import React from 'react';
import { number, string } from 'prop-types';
import useStyles from '../../hooks/useStyles';
import LogoType from './LogoType';
import LogoCircle from './LogoCircle';

LogoBranded.propTypes = {
	className: string,
	width: number,
	height: number,
	size: number,
	label: string
};

/**
 * Logo containing both the symbol and the name
 */
export default function LogoBranded({ className, ...rest }) {
	const classes = useStyles(styles);
	return (
		<div css={classes.root} className={className}>
			<LogoCircle {...rest} css={classes.logoCircle} />
			<LogoType {...rest} css={classes.logoType} />
		</div>
	);
}

// By default the logo uses the default brand colours defined within the SVG file.
// To override this set `props.brandColors` to false which allows the circle colour
// to be controlled via a parent element's CSS `color` property.
const styles = ({ css }) => ({
	root: css`
		display: flex;
	`,
	logoType: css`
		width: 72%;
		margin-top: 1%;
	`,
	logoCircle: css`
		margin-right: 8%;
		width: 20%;
	`
});
